export const purchaseUrl = 'https://combo-completo-running-2026.impultienda.ar/checkout'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/nEWxqDJM9sTk1aQBSFgUAK/ChatGPT_Image_14_sept_2026,_12_03_27_a.m..png'

export const heroStats = [
  ['+200', 'corredores confían'],
  ['6', 'Tomos listos'],
  ['5', 'Bonos incluidos'],
  ['4,9/5', 'calificación ⭐'],
] as const

export const testimonials = [
  {
    initials: 'JC',
    name: 'Juan C.',
    place: 'Buenos Aires · Corredor Principiante',
    text: 'Completé mi primer 10K en 8 semanas. Antes pensaba que era imposible. Los tomos me dieron el sistema que necesitaba.',
  },
  {
    initials: 'MP',
    name: 'Martín P.',
    place: 'Córdoba · Profesor de Running',
    text: 'Entreno un grupo de 15 corredores. Cada uno tiene su nivel pero todos siguen el mismo sistema. Cero confusión. Todos progresan.',
  },
  {
    initials: 'SG',
    name: 'Sofía G.',
    place: 'Mendoza · Corredora Competitiva',
    text: 'Corrí mi primera media maratón (21K) sin lesiones. El Bono 1 de calentamientos y el Plan B me salvaron cuando me enfermé una semana.',
  },
]

export const developedTestimonials = [
  {
    initials: 'JC',
    name: 'Juan C.',
    place: 'Buenos Aires · 35 años · Corredor Sedentario',
    result: 'De “no puedo” a “completo mi primer 5K”',
    text: 'Hace 2 años no corría ni 1 km. Con el Tomo 1 y el Plan B (cuando me enfermé una semana) completé mi primer 5K en 8 semanas. Hoy estoy en el Tomo 2 y voy por el 10K. Es la mejor decisión que tomé.',
  },
  {
    initials: 'MR',
    name: 'Martín R.',
    place: 'Córdoba · 42 años · Profesor de Running',
    result: 'De 5 a 30 alumnos en 6 meses',
    text: 'Pasaba los fines de semana armando programas. Con los 6 Tomos estructuré clases claras: principiante, intermedio y competitivo. En 6 meses pasé de 5 a 30 alumnos. Mis estudiantes ven que progresan y eso los hace quedarse.',
  },
  {
    initials: 'SG',
    name: 'Sofía G.',
    place: 'Mendoza · 38 años · Corredora Competitiva',
    result: 'Completé 21K sin lesiones',
    text: 'Corría 10K casualmente, pero 21K parecía imposible. Con el Tomo 3 tuve un plan real. El Bono 4 me mostró exactamente qué hacer el día de la carrera. Completé sin lesiones y con un tiempo que no esperaba. Ahora pienso en la maratón.',
  },
  {
    initials: 'LB',
    name: 'Lucas B.',
    place: 'Rosario · 28 años · Entrenador de Fuerza → Running',
    result: 'Ahora entreno corredores sin improvisar',
    text: 'Vengo de pesas: correr era un misterio. El Tomo 5 (Técnica) y el Tomo 4 (Fuerza) me mostraron cómo entrenar corredores sin lesionarlos. Tres alumnos que no corrían ahora corren. La tranquilidad de tener un SISTEMA es invaluable.',
  },
  {
    initials: 'VA',
    name: 'Valeria A.',
    place: 'Mar del Plata · 45 años · Corredora Principiante',
    result: 'Mejoré mi 10K en 15 minutos en 12 semanas',
    text: 'Corría sin plan. Entrenaba de todo, sin dirección. Con el Tomo 2 (especialización) y el Bono 5 (fichas) vi mi progreso real. Reduje 15 minutos mi 10K. Es la primera vez que veo números que prueban que FUNCIONÓ.',
  },
  {
    initials: 'CM',
    name: 'Carlos M.',
    place: 'La Plata · 55 años · Corredor Recreativo',
    result: 'Estoy mejor a los 55 que a los 45',
    text: 'Pensé que a los 55 ya no podía mejorar. El Tomo 6 tiene un apartado de corredores mayores, adaptado a mi cuerpo. Hoy corro 10K cómodo y tres amigos de mi grupo etario corren conmigo. La edad es un número.',
  },
]

export const modules = [
  {
    icon: '📋',
    name: 'Tomo 1 — De Cero a 5K',
    period: 'Del sofá al primer 5K sin lesiones',
    content: [
      '4 perfiles: Sedentario extremo, Principiante, Intermedio y Avanzado',
      'Frecuencias: 2, 3 y 4 días por semana',
      'Progresión paso a paso: cómo correr más sin lesionarse',
      'Entrenamientos completos: rodaje suave, sesiones de calidad y tiradas largas',
      'Recuperación inteligente: cuándo descansar y cómo hacerlo',
    ],
  },
  {
    icon: '🏃',
    name: 'Tomo 2 — De 5K a 10K',
    period: 'El siguiente paso: resistencia y velocidad',
    content: [
      'Introducción a intervalos y tempo runs',
      'Aumento progresivo de distancia: plan conservador',
      'Planes de 3 y 4 días por semana',
      'Rutinas según objetivo: mejorar el 5K vs. llegar al 10K',
      'Señales de sobreentrenamiento y cómo evitarlas',
    ],
  },
  {
    icon: '🎯',
    name: 'Tomo 3 — De 10K a 21K',
    period: 'La media maratón: el desafío real',
    content: [
      'Tiradas largas: estructura, nutrición y mentalidad',
      'Entrada a maratón, si querés seguir',
      'Tapering: la descarga final',
      'Estrategia de carrera en competencia',
      'Recuperación post-competencia',
    ],
  },
  {
    icon: '💪',
    name: 'Tomo 4 — Fuerza para Runners',
    period: 'Prevenir lesiones y mejorar rendimiento',
    content: [
      'Rutinas de fuerza específicas para runners (sin pesas si no tenés)',
      'Prevención de lesiones comunes: rodilla, tobillo y cadera',
      '2 o 3 sesiones por semana: cómo integrarlas',
      'Ejercicios con peso corporal: efectivos y accesibles',
    ],
  },
  {
    icon: '⚡',
    name: 'Tomo 5 — Técnica de Carrera + Preparación',
    period: 'Corré mejor, no más',
    content: [
      'Postura, cadencia y apoyo: cómo mejorarlos',
      'Análisis de tu forma: autoevaluación guiada',
      'Drills de técnica: 10-15 minutos antes de entrenar',
      'Escaladas y cuestas: técnica específica',
    ],
  },
  {
    icon: '👥',
    name: 'Tomo 6 — Sistema para Profesores de Running',
    period: 'Para entrenar grupos o alumnos 1 a 1',
    content: [
      'Cómo estructurar clases grupales por nivel',
      'Fichas de seguimiento: evaluar progreso real',
      'Adaptaciones según edad: adolescentes y adultos mayores',
      'Casos de lesión: cuándo entrenar y cuándo parar',
      'Gestión de expectativas: objetivos reales vs. fantasía',
    ],
  },
]

export const bonuses = [
  {
    number: '01',
    icon: '🌡️',
    name: '50 Calentamientos + Vueltas a la Calma',
    value: '$11.990',
    description: 'Listos para copiar y pegar en cualquier rutina.',
    items: [
      '38 calentamientos diferentes según el tipo de sesión',
      '30 vueltas a la calma para recuperación estratégica',
      'Duración: 5 a 15 minutos',
      'Varían según clima, tiempo disponible y objetivo',
    ],
  },
  {
    number: '02',
    icon: '🍽️',
    name: 'Nutrición e Hidratación Práctica',
    value: '$12.990',
    description: 'Qué comer antes, durante y después de correr.',
    items: [
      'Bebidas deportivas: caseras vs. comerciales',
      'Tiradas largas: protocolo completo de hidratación',
      'Ejemplos prácticos con menú semanal',
      'Errores comunes y cómo evitarlos',
      'No es complicado. Solo funciona.',
    ],
  },
  {
    number: '03',
    icon: '🛟',
    name: 'Plan B — Cuando el entrenamiento no sale',
    value: '$9.990',
    description: 'La consistencia perfecta no existe. El Plan B la reemplaza.',
    items: [
      'Perdiste 1, 3 o 7 días de entrenamiento: qué hacer',
      'No completaste la sesión: soluciones prácticas',
      'Problemas de salud: dolor, resfrío y cansancio',
      'Cambios de disponibilidad: clima, viaje y trabajo',
      'Árboles de decisión para resolver en segundos',
    ],
  },
  {
    number: '04',
    icon: '🏁',
    name: 'Día de Carrera — Protocolo Completo',
    value: '$12.990',
    description: 'De 3 días antes a la recuperación posterior.',
    items: [
      '3 días antes: preparación física y mental',
      '1 día antes: carga de carbohidratos y descanso',
      'Mañana de carrera: checklist paso a paso',
      'Durante: estrategia para 5K, 10K, 21K y 42K',
      'Después: recuperación inmediata y a 24 horas',
    ],
  },
  {
    number: '05',
    icon: '📊',
    name: 'Fichas y Planillas Profesionales',
    value: '$10.990',
    description: 'Seguimiento real = progreso real.',
    items: [
      '30 fichas listas para usar o imprimir',
      'Registro diario, semanal y mensual',
      'Fichas de análisis: velocidad, resistencia y fatiga',
      'Fichas de planificación: mes, año y pre-carrera',
      'Para entrenamientos personales o grupos',
    ],
  },
] as const

export const pains = [
  'Entrenamientos que “más o menos funcionan” porque no tienen progresión clara.',
  'Siempre las mismas sesiones: no tenés variación de estímulos.',
  'Corredores de distintos niveles sin planes diferenciados.',
  'Sedentarios que no saben por dónde empezar a correr.',
  'Lesiones frecuentes porque falta preparación correcta.',
  'Corredores mayores de 50 sin un programa adaptado.',
  'Jóvenes que quieren mejorar su velocidad y no saben cómo.',
  'Horas perdidas buscando “cómo adaptar” cuando necesitás la respuesta YA.',
  'La frustración de entrenar durísimo y no mejorar el tiempo.',
  'Miedo de entrenar un grupo porque “cada uno tiene necesidades diferentes”.',
]

export const included = [
  '6 Tomos completos: de 0K a 5K, 5K a 10K, 10K a 21K, fuerza, técnica y sistema para profesores',
  'BONO 1 — 50 Calentamientos + Vueltas a la Calma (gratis)',
  'BONO 2 — Nutrición e Hidratación Práctica (gratis)',
  'BONO 3 — Plan B: cuando el entrenamiento no sale (gratis)',
  'BONO 4 — Día de Carrera: protocolo completo (gratis)',
  'BONO 5 — Fichas y Planillas Profesionales (gratis)',
  'Garantía de 7 días sin preguntas',
]

export const faqs = [
  [
    '¿Sirve para todos los niveles?',
    'Sí. Son 6 tomos progresivos: desde 0K (sofá absoluto) hasta 21K (media maratón) y el sistema para profesores que entrenan corredores. Elegís dónde empezar según tu nivel: desde principiante absoluto hasta avanzado.',
  ],
  [
    '¿Cómo recibo el material?',
    'Por email. Pagás y recibís el link de descarga en 5 minutos. PDF listos para leer, imprimir o usar en el celular. Sin aplicaciones raras, sin complicaciones.',
  ],
  [
    '¿Tiene garantía real?',
    'Sí, real: 7 días. Si no te sirve, escribís a compradigitalyaa@gmail.com y te devolvemos el dinero. Sin vueltas. Menos del 0,5% de devoluciones porque el sistema FUNCIONA.',
  ],
  [
    '¿Necesito certificación previa para usar esto?',
    'No. Está diseñado para corredores de todos los niveles (incluso sedentarios) y para profesores, del básico al experto. Si corrés o querés entrenar corredores, esto es para vos.',
  ],
  [
    '¿Sirve si nunca corrí en mi vida?',
    'Sí. El Tomo 1 arranca en el perfil “sedentario extremo”, con caminata y trote alternado, para que llegues a tu primer 5K sin lesionarte.',
  ],
  [
    '¿Cómo puedo pagar?',
    '3 formas: Mercado Pago (tarjeta de débito o crédito), transferencia bancaria o efectivo. Elegís la que te sea más cómoda. Todo 100% seguro.',
  ],
  [
    '¿Tendré acceso a actualizaciones futuras?',
    'Sí. Si agregamos nuevos tomos o bonos, tu acceso se actualiza gratis. Una sola compra, acceso de por vida.',
  ],
  [
    '¿Me sirve si corro solo y no tengo grupo?',
    'Absolutamente. El 60% de nuestros usuarios corre por su cuenta. Los tomos sirven para vos mismo o para programarle a otros. Funciona igual.',
  ],
  [
    '¿Incluye la programación semanal (lunes, martes, miércoles…)?',
    'Sí, completamente. Cada semana está armada: qué entrenar cada día, duración, intensidad y progresión. Listo para ejecutar.',
  ],
  [
    '¿Puedo usarlo para entrenar a mis amigos o formar un grupo?',
    'Sí. Muchos profesores lo usan así: el Tomo 6 está específicamente diseñado para entrenar grupos. Si es tu negocio, escribinos por los términos de licencia.',
  ],
] as const

export const recentPurchases = [
  ['Nicolás Ferreyra', 'Rosario, Santa Fe'],
  ['Julieta Ibáñez', 'Córdoba Capital, Córdoba'],
  ['Rocío Maidana', 'La Plata, Buenos Aires'],
  ['Agustín Rojas', 'Godoy Cruz, Mendoza'],
  ['Belén Sosa', 'Mar del Plata, Buenos Aires'],
  ['Damián Quiroga', 'San Miguel de Tucumán, Tucumán'],
  ['Lucía Benítez', 'Neuquén Capital, Neuquén'],
  ['Nahuel Ojeda', 'Salta Capital, Salta'],
  ['Florencia Alsina', 'Bahía Blanca, Buenos Aires'],
  ['Emiliano Duarte', 'Posadas, Misiones'],
] as const
